import {Card} from 'platform/components';
import {Align, Box, Heading, Hide, Text, VStack} from 'platform/foundation';

import {Trans} from 'react-i18next';

import {isNil} from 'ramda';

import {suffixTestId, TestIdProps} from 'shared/web';

import {Alert} from '../../../../components/Alert/Alert';
import {AvoidBreakInside} from '../../../../components/AvoidBreakInside/AvoidBreakInside';
import i18n from '../../../../i18n/i18n';
import {MarketType} from '../../../../types/MarketType';
import {VehicleType} from '../../../../types/VehicleType';
import {useIsPrintForced} from '../../hooks/useIsPrintForced';
import {VATChart} from './components/VATChart';

interface StatisticsCardVATProps extends TestIdProps {
  vehicle: VehicleType;
  market?: MarketType;
}

export function StatisticsCardVAT(props: StatisticsCardVATProps) {
  const {isPrint} = useIsPrintForced();
  const isDeductible = props.vehicle.isVatDeductible;

  return (
    <Hide when={isNil(props.market?.vatChart)}>
      <AvoidBreakInside>
        <Card variant={isPrint ? 'inlineWhite' : undefined} data-testid={props['data-testid']}>
          <Box padding={2}>
            <VStack spacing={6}>
              <Align center>
                <Heading size={3} data-testid={suffixTestId('vatTitle', props)}>
                  {i18n.t('entity.overviewStatistics.labels.vatTitle')}
                </Heading>
              </Align>
              <Text
                align="center"
                size="small"
                color="secondary"
                data-testid={suffixTestId('vatDescription', props)}
              >
                <Trans
                  i18nKey="entity.overviewStatistics.labels.vatDescription"
                  components={{bold: <Text key="bold" alternative inline size="small" />}}
                />
              </Text>

              <VATChart
                vatChartData={props.market?.vatChart}
                data-testid={suffixTestId('vatChart', props)}
              />

              <Alert
                variant={isDeductible ? 'success' : 'warning'}
                icon={isDeductible ? 'action/trending_up' : 'action/trending_down'}
                data-testid={suffixTestId('vatAlert', props)}
              >
                <Trans
                  i18nKey={
                    isDeductible
                      ? 'entity.overviewStatistics.labels.vatDeductibleAlert'
                      : 'entity.overviewStatistics.labels.vatNonDeductibleAlert'
                  }
                  components={{bold: <Text key="bold" alternative inline size="small" />}}
                />
              </Alert>
            </VStack>
          </Box>
        </Card>
      </AvoidBreakInside>
    </Hide>
  );
}
